<script>
import {
  redirectToContactUs,
  redirectToHome,
  redirectToLogin
} from "../../helpers/routerHelper";
import propertyIconSet from "../package/propertyIconSet.vue";
import FooterSection from "../package/footerSection.vue";
import HeaderSection from "../package/HeaderSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import ContactUsImage from "../contact/contactUsImage.vue";
import BreadcrumbContactUs from "../contact/breadcrumbContactUs.vue";
import EmailUsSectionLight from "../contact/emailUsSectionLight.vue";
import BreadcrumbAboutUs from "./breadcrumbAboutUs.vue";
import AboutUsContent from "./aboutUsContent.vue";
import AboutUsImage from "./aboutUsImage.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";

export default {
  name: "aboutUsLayout",
  components: {
    // MobileAppDownload,
    AboutUsImage,
    AboutUsContent,
    BreadcrumbAboutUs,
    EmailUsSectionLight,
    BreadcrumbContactUs,
    ContactUsImage,
    DrawerAside,
    HeaderSection,
    FooterSection,
    propertyIconSet
  },
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: About Us";
  },
  created() {
    document.title = "UNIFI Property: About Us";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    redirectToContactUs,
    redirectToHome,
    redirectToLogin,
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <breadcrumb-about-us />
        <about-us-image />
        <about-us-content />
        <property-icon-set />
        <email-us-section-light />
<!--        <mobile-app-download />-->
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}
</style>



// WEBPACK FOOTER //
// src/components/about/aboutUsLayout.vue